type Props = {
  color?: string;
};

export default function SelectDropdownLgIcon({
  color = "currentColor",
}: Props) {
  return (
    <span className="ant-select-suffix">
      <svg
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 1L9 8.5L1.5 1"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
